export default "__VITE_ASSET__47ecf99c__"